import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    id: string;
};

export const schemaUserResolver_IsLocked = z.boolean();

export type SchemaUserResolver_IsLocked = z.infer<typeof schemaUserResolver_IsLocked>;

export type UserResolver_IsLocked = Resolver<Arguments, SchemaUserResolver_IsLocked>;
